import React from 'react'
import { PropTypes } from 'prop-types'

/*
* Pass in props in form of :-
 * headers [ {headerName: 'name', 'dataKey':'someKey', selectable: boolean} ]
 * selectionCallBack: function(index, value)
 * data [{someKey:value, otherKey: otherValue}]
 */

const generateHeaders = (headers) => {
  const header = (
    <tr className="ln-c-table__row ln-c-table__header-row ">
      {
        headers.map(headerData => (<th key={headerData.columnName} className="ln-c-table__header-cell">{headerData.columnName}
          {headerData.toolTip &&
          <span className="c-tooltip">
            <span className="c-tooltip-field-info" />
            <span className="c-tooltip-field-text">{headerData.toolTip}</span>
          </span>
          } </th>))
      }
    </tr>
  )
  return header
}

const generateColumnBody = (i, row, columnKey, onDrillDown) => {
  if (i === 0 && onDrillDown) {
    return <a href="" onClick={(e) => { onDrillDown(e, row) }}>{row[columnKey]}</a>
  }
  return <span>{row[columnKey]}</span>
}

const generateRows = (headers, data, onDrillDown) => {
  const body = data.map(row => (
    <tr key={row.id} className="ln-c-table__row">
      {headers.map((headerData, i) => (
        <td key={headerData.columnKey} className="ln-c-table__cell" style={{ width: '12%' }}>
          {generateColumnBody(i, row, headerData.columnKey, onDrillDown)}
        </td>))}
    </tr>)
  )

  return body
}

const ResultList = (props) => {
  const { headers, data, onDrillDown } = props
  return (
    <div className="ln-c-table-container u-overflow-visible">
      <table className="ln-c-table">
        <thead className="ln-c-table__header">
          {generateHeaders(headers)}
        </thead>
        <tbody className="ln-c-table__body">
          {generateRows(headers, data, onDrillDown)}
        </tbody>
      </table>
    </div>
  )
}

ResultList.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.shape({
    columnName: PropTypes.string.isRequired,
    columnKey: PropTypes.string.isRequired
  })).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDrillDown: PropTypes.func
}

export default ResultList



// WEBPACK FOOTER //
// ./src/components/Reporting/ResultList/index.jsx